import { Input } from "@/modern/components/ui/input";
import { Search, X } from "lucide-react";
import { useMyMediaContext } from "../context/MyMediaContext";
import { Button } from "@/modern/components/ui/button";

export const SearchBar = () => {
  const { searchQuery, setSearchQuery } = useMyMediaContext();

  return (
    <div className="relative">
      <Search className="absolute left-3 top-1/2 transform -translate-y-1/2 h-4 w-4 text-muted-foreground z-10" />
      <Input
        type="text"
        placeholder="Search files by name..."
        value={searchQuery}
        onChange={(e) => setSearchQuery(e.target.value)}
        className="pl-9 pr-9 h-10"
      />
      {searchQuery && (
        <Button
          variant="ghost"
          size="icon"
          className="absolute right-1 top-1/2 transform -translate-y-1/2 h-8 w-8"
          onClick={() => setSearchQuery("")}
        >
          <X className="h-4 w-4" />
        </Button>
      )}
    </div>
  );
};
